import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { supabase } from "../supabase/supabaseClient";
import "../style/homepage.css";
import Footer from "../components/Footer";
import Header from "../components/Header";

function Homepage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCars = async () => {
    const { data, error } = await supabase
      .from("cars")
      .select("*")
      .order("created_at", { ascending: false });

    if (error) {
      console.error("Supabase cars error:", error.message);
      setLoading(false);
      return;
    }

    setCars(data || []);
    setLoading(false);
  };

  useEffect(() => {
    fetchCars();

    const channel = supabase
      .channel("homepage-cars-realtime")
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "cars",
        },
        () => {
          fetchCars();
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  return (
    <div className="main-wrapper">
      <Header />

      <div className="hero-container">
        <div className="hero-content">
          <h1 className="title">
            {t("home.heroTitleStart")}{" "}
            <span className="highlight">{t("home.heroTitleHighlight")}</span>
          </h1>

          <button className="btn primary" onClick={() => navigate("/cars")}>
            {t("home.browseInventory")}
          </button>
        </div>
      </div>

      <section className="featured-section">
        <div className="section-header">
          <h2>{t("home.featuredTitle")}</h2>
          <p>{t("home.featuredText")}</p>
        </div>

        {loading ? (
          <p style={{ textAlign: "center" }}>{t("home.loadingCars")}</p>
        ) : cars.length === 0 ? (
          <p style={{ textAlign: "center" }}>{t("home.noCars")}</p>
        ) : (
          <div className="car-grid">
            {cars.slice(0, 3).map((car) => {
              const carImage =
                car.image_url ||
                car.image ||
                car.main_image ||
                car.photo_url ||
                car.photos?.[0] ||
                car.images?.[0] ||
                "https://via.placeholder.com/800x500?text=No+Image";

              return (
                <div className="car-card" key={car.id}>
                  <div className="car-image-container">
                    <img
                      src={carImage}
                      alt={car.car_name || car.name || car.model || "Car"}
                    />

                    <div className="availability-tag">
                      <span className="dot"></span> {t("home.available")}
                    </div>
                  </div>

                  <div className="car-info">
                    <div className="car-header">
                      <h3>
                        {car.car_name ||
                          car.name ||
                          car.model ||
                          t("home.unnamedCar")}
                      </h3>

                      <span className="year">{car.year || "N/A"}</span>
                    </div>

                    <p className="brand">
                      {car.brand || car.make || t("home.unknownBrand")}
                    </p>

                    <div className="car-footer">
                      <span className="price">
                        {car.price ? `€${car.price}` : t("home.priceRequest")}
                      </span>

                      <button
                        className="btn-details"
                        onClick={() => navigate(`/cars/${car.id}`)}
                      >
                        {t("home.viewDetails")}
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </section>

      <section className="why-section">
        <div className="why-header">
          <h2>{t("home.whyTitle")}</h2>
          <p>{t("home.whyText")}</p>
        </div>

        <div className="why-grid">
          <div className="why-card">
            <div className="icon">🏅</div>
            <h3>{t("home.qualityTitle")}</h3>
            <p>{t("home.qualityText")}</p>
          </div>

          <div className="why-card">
            <div className="icon">🛡️</div>
            <h3>{t("home.trustedTitle")}</h3>
            <p>{t("home.trustedText")}</p>
          </div>

          <div className="why-card">
            <div className="icon">⚡</div>
            <h3>{t("home.fastTitle")}</h3>
            <p>{t("home.fastText")}</p>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <h2>{t("home.ctaTitle")}</h2>
        <p>{t("home.ctaText")}</p>

        <button className="cta-btn" onClick={() => navigate("/contact")}>
          {t("home.contactButton")} →
        </button>
      </section>

      <Footer />
    </div>
  );
}

export default Homepage;